import { __assign, __read } from "tslib";
import React, { useState, useLayoutEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import { select } from 'd3-selection';
import { StyledRect } from './block.styles';
var rectMotion = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    exit: { opacity: 0 },
};
var rectHoverMotion = {
    scale: 1.05,
    transition: { duration: 0.3 },
};
var Block = function (_a) {
    var block = _a.block, padding = _a.padding, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    var _b = __read(useState(false), 2), isActive = _b[0], setActive = _b[1];
    var element = useRef(null);
    useLayoutEffect(function () {
        if (isActive && element.current) {
            select(element.current).raise();
        }
    }, [isActive]);
    var width = block.width, height = block.height, x = block.x, y = block.y, color = block.color;
    return (React.createElement(motion.g, __assign({ ref: element }, rectMotion, { onMouseEnter: function (e) {
            onMouseEnter(e, block);
            setActive(true);
        }, onMouseMove: function (e) {
            onMouseEnter(e, block);
        }, onMouseLeave: function (e) {
            onMouseLeave(e);
            setActive(false);
        }, whileHover: rectHoverMotion }),
        React.createElement(StyledRect, { dropShadow: isActive, width: width - padding, height: height - padding, x: x + padding / 2, y: y + padding / 2, fill: color, stroke: isActive ? 'white' : 'none', strokeWidth: isActive ? 4 : 0 })));
};
export default Block;
